import { createContext, useContext, type ReactNode } from "react";

// Read-only school-preview mode. When a KUVO staff member with preview access opens a school's
// portal, the SchoolAccessGuard wraps it in this provider so the guided-flow shells render their
// inputs disabled (the server independently blocks every write — this is UX polish, not the
// security boundary). Defaults to false everywhere else, so a real coordinator's portal is never
// affected.
const PreviewModeContext = createContext<boolean>(false);

export function PreviewModeProvider({ children }: { children: ReactNode }) {
  return <PreviewModeContext.Provider value={true}>{children}</PreviewModeContext.Provider>;
}

/** True only inside a read-only staff preview of a school portal. */
export function usePreviewMode(): boolean {
  return useContext(PreviewModeContext);
}
